(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .factory('swifPatrimoinePurchaseModeService', swifPatrimoinePurchaseModeService)
    .controller('PatrimoinePurchaseModeController', PatrimoinePurchaseModeController);

    /**
    * @ngdoc service
    * @name swif.patrimoine.swifPatrimoinePurchaseModeService
    * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoinePurchaseModeService(swif) {
        var service = {};
        service.getCollection = function () {
            return swif.collections.getCollection('purchase_modes');
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate(
                'purchase_modes',
                'patrimoine_purchase_mode',
                filter
            );
        };
        service.preModal = function (data) {
            service.getCollection().preModal(data);
        };
        service.preValidate = function (data) {
            return service.getCollection().preValidate(data);
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        return service;
    }

    function PatrimoinePurchaseModeController($scope, swif, swifPatrimoinePurchaseModeService) {
        var service = swifPatrimoinePurchaseModeService;
        console.log('init PatrimoinePurchaseModeController');
        service.createCollection()
        .then(function (collection) {
            $scope.purchase_modes = collection;
        });
        $scope.preModal = service.preModal;
        $scope.preValidate = service.preValidate;
        $scope.callback = service.callback;
    }

})();
